import React from "react";
import { useAddOnProducts } from "./useAddOnProducts.hook";
import { AddOnProductCard } from "./addOnProductCard.comp";
import { useTranslation } from "../../core/translation.core";
import { LoadingComp } from "../common/loading.comp";
import { AddOnDiscountGroup, CartItem } from "../../types/cart";
import { useCart } from "../../hooks/cart/useCart.hook";

export function AddOnProductsSection() {
  const { cart } = useCart();

  const cartItems = cart?.items;
  const productIds = cartItems?.filter((item) => !item.attachCartItemId).map((item) => item.product.id);

  const { data: addOnDiscountGroups, isLoading, isError } = useAddOnProducts(productIds);

  if (!productIds) return null;
  if (productIds.length === 0) return null;

  if (isLoading) {
    return (
      <div className="bg-white rounded-lg overflow-hidden mt-4 p-8">
        <LoadingComp />
      </div>
    );
  }

  if (isError) return null;

  if (!addOnDiscountGroups || addOnDiscountGroups.length === 0) return null;

  return (
    <>
      {addOnDiscountGroups.map((group) => (
        <Item key={group.id} addOnDiscountGroup={group} />
      ))}
    </>
  );
}

function Item({ addOnDiscountGroup }: { addOnDiscountGroup: AddOnDiscountGroup }) {
  const { t, msg } = useTranslation();

  return (
    <div className="bg-white rounded-lg overflow-hidden mt-4">
      <div className="px-4 py-3 bg-guru-rustedGold text-white">
        <h2 className="text-lg font-bold">
          {t(msg.addOnDiscount.title)} ({addOnDiscountGroup.name})
        </h2>
        <p className="text-sm opacity-90 whitespace-pre-line">{addOnDiscountGroup.description}</p>
      </div>

      <div className="p-4 grid grid-cols-2 lg:grid-cols-3 gap-4">
        {addOnDiscountGroup.products.map((product) => (
          <AddOnProductCard key={`${product.addOnDiscountId}-${product.product.id}`} product={product} />
        ))}
      </div>
    </div>
  );
}
